
define('text!js-translation.json',[],function () { return '{"Choose one of the following shipping methods":"We only send via insured shipping.","Choose one of the shipping options":"Shipping","Kostenloser Versand":"Free Shipping"}';});

